import TreeSelect from './TreeSelect';

export default TreeSelect;

export { default as TreeSelectField } from './TreeSelectField';
export { default as TreeSelectItem } from './components/TreeSelectItem';
